import { useCallback, useRef } from "react";
import { isFocusableElement as A, FocusableMode as h } from "../utils/focus-management.js";
import { isMobile as n } from "../utils/platform.js";
import { useDocumentEvent as i } from "./use-document-event.js";
import { useIsTopLayer as x } from "./use-is-top-layer.js";
import { useLatestValue as s } from "./use-latest-value.js";
import { useWindowEvent as s$1 } from "./use-window-event.js";
const E = 30;
function R(p, f, C) {
  let u = x(p, "outside-click"), m = s(C), s$2 = useCallback(function(e, n2) {
    if (e.defaultPrevented) return;
    let r = n2(e);
    if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
    let h$1 = function l(o) {
      return typeof o == "function" ? l(o()) : Array.isArray(o) || o instanceof Set ? o : [o];
    }(f);
    for (let l of h$1) if (l !== null && (l.contains(r) || e.composed && e.composedPath().includes(l))) return;
    return !A(r, h.Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
  }, [m, f]), i$1 = useRef(null);
  i(u, "pointerdown", (t) => {
    var e, n2;
    i$1.current = ((n2 = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n2[0]) || t.target;
  }, true), i(u, "mousedown", (t) => {
    var e, n2;
    i$1.current = ((n2 = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n2[0]) || t.target;
  }, true), i(u, "click", (t) => {
    n() || i$1.current && (s$2(t, () => i$1.current), i$1.current = null);
  }, true);
  let a = useRef({ x: 0, y: 0 });
  i(u, "touchstart", (t) => {
    a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
  }, true), i(u, "touchend", (t) => {
    let e = { x: t.changedTouches[0].clientX, y: t.changedTouches[0].clientY };
    if (!(Math.abs(e.x - a.current.x) >= E || Math.abs(e.y - a.current.y) >= E)) return s$2(t, () => t.target instanceof HTMLElement ? t.target : null);
  }, true), s$1(u, "blur", (t) => s$2(t, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), true);
}
export {
  R as useOutsideClick
};
